// components/PaidBillDropdownButton.js

import React from 'react';
import { MDBDropdown, MDBDropdownMenu, MDBDropdownToggle, MDBDropdownItem } from 'mdb-react-ui-kit';

export default function PaidBillDropdownButton({ billId, onClick, isPaid, isOverdue }) {
  const handleDropdownButtonClick = (title) => {
    onClick(billId, title);
  };

  const toggleColorStyle = {
    backgroundColor: isPaid ? '#A0C2BB' : (isOverdue ? '#d9534f' : '#EDBC07'),  // Red if overdue and unpaid, otherwise yellow for unpaid
    color: isOverdue && !isPaid ? '#ffffff' : 'inherit',  // White text if overdue and unpaid
  };

  return (
    <MDBDropdown>
      <MDBDropdownToggle style={toggleColorStyle}>
        {isPaid ? 'Paid' : 'Unpaid'}
      </MDBDropdownToggle>
      <MDBDropdownMenu>
        {isPaid ? (
          // Only show Unpaid option when the bill is paid
          <>
            <MDBDropdownItem
              link
              childTag='button'
              onClick={() => handleDropdownButtonClick('Unpaid')}
            >
              Unpaid
            </MDBDropdownItem>
            <MDBDropdownItem
              link
              childTag='button'
              onClick={() => handleDropdownButtonClick('Update')}
            >
              Update
            </MDBDropdownItem>
            <MDBDropdownItem
              link
              childTag='button'
              onClick={() => handleDropdownButtonClick('Delete')}
              className="text-danger"
              style={{ fontWeight: 'bold' }}
            >
              Delete
            </MDBDropdownItem>
          </>
        ) : (
          // Show all payment options when the bill is unpaid
          <>
            <MDBDropdownItem
              link
              childTag='button'
              onClick={() => handleDropdownButtonClick('PaidDue')}
            >
              Paid on Due Date
            </MDBDropdownItem>
            <MDBDropdownItem
              link
              childTag='button'
              onClick={() => handleDropdownButtonClick('Today')}
            >
              Paid Today
            </MDBDropdownItem>
            <MDBDropdownItem
              link
              childTag='button'
              onClick={() => handleDropdownButtonClick('Yesterday')}
            >
              Paid Yesterday
            </MDBDropdownItem>
            <MDBDropdownItem
              link
              childTag='button'
              onClick={() => handleDropdownButtonClick('PaidOn')}
            >
              Paid on...
            </MDBDropdownItem>
            <MDBDropdownItem
              link
              childTag='button'
              onClick={() => handleDropdownButtonClick('Update')}
            >
              Update
            </MDBDropdownItem>
            <MDBDropdownItem
              link
              childTag='button'
              onClick={() => handleDropdownButtonClick('Delete')}
              className="text-danger"
              style={{ fontWeight: 'bold' }}
            >
              Delete
            </MDBDropdownItem>
          </>
        )}
      </MDBDropdownMenu>
    </MDBDropdown>
  );
}
